import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-icone-moedas',
  standalone: true,
  imports: [],
  templateUrl: './icone-moedas.component.html',
  styleUrl: './icone-moedas.component.scss',
})
export class IconeMoedasComponent implements OnInit, OnChanges {
  @Input() preenchido: boolean = false;
  @Input() bloqueado: boolean = false;

  corDaBorda: string = '#7F1517';
  corDoCirculo: string = 'white';
  corDoIcone: string = '#7F1517';

  ngOnInit() {
    if (this.preenchido) {
      this.bloqueado = true;
      this.definirEsquemaDeCoresPreenchidas();
      return;
    }

    this.definirEsquemaDeCoresVazio();
  }

  ngOnChanges(changes: any): void {
    if (
      changes.bloqueado &&
      changes.bloqueado.previousValue === false &&
      changes.bloqueado.currentValue === true
    ) {
      this.definirEsquemaDeCoresPreenchidas();
      return;
    }

    if (this.preenchido === true && !this.bloqueado) {
      this.definirEsquemaDeCoresPreenchidas();
      return;
    }

    if (this.preenchido === false && !this.bloqueado) {
      this.definirEsquemaDeCoresVazio();
    }
  }

  definirEsquemaDeCoresPreenchidas() {
    this.corDaBorda = '#7F1517';
    this.corDoCirculo = '#7F1517';
    this.corDoIcone = 'white';
  }

  definirEsquemaDeCoresVazio() {
    this.corDaBorda = '#7F1517';
    this.corDoCirculo = 'white';
    this.corDoIcone = '#7F1517';
  }
}
